import React from 'react';
import BRAND from '../config/brand';
import './PrivacyPolicyPage.css';

const updatedDate = 'October 16, 2026';

function TermsOfUsePage() {
  return (
    <main className="privacy-page">
      <header className="privacy-header">
        <a className="privacy-logo-link" href="/" aria-label="Bautista Planning and Analytics home">
          <img
            src={BRAND.logoSrc}
            alt="Bautista Planning and Analytics"
            className="privacy-logo"
            width={300}
            height={60}
            decoding="async"
          />
        </a>
        <p className="privacy-kicker">Website Terms of Use</p>
        <h1>Bautista Planning and Analytics, LLC</h1>
        <p className="privacy-date">Effective and last updated: {updatedDate}</p>
      </header>

      <section className="privacy-section privacy-intro">
        <p>
          These Terms of Use apply to this website, its calculators, and its public pages. By using the
          site, you agree to these terms. If you do not agree, please do not use the site. Clients who use
          the secure client portal are also bound by their signed advisory agreement, which controls if it
          conflicts with these terms.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Educational Information, Not Personalized Advice</h2>
        <p>
          Content and calculators on this site are general and educational. They are not personalized
          investment, tax, legal, or financial advice, and they are not an offer or solicitation to buy or
          sell any security or advisory service. Using the site, a calculator, or a contact form does not
          create an advisory relationship. An advisory relationship begins only after we both sign a written
          agreement.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Calculators and Estimates</h2>
        <p>
          Calculator results are estimates based on the information you enter and on simplified
          assumptions, such as tax rules, inflation, and rates of return, that may not match your situation.
          Results are hypothetical, are not guarantees of future results, and may change as laws, markets,
          and assumptions change. Past performance does not guarantee future results. Review important
          decisions with a qualified professional before acting.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Registration and Jurisdiction</h2>
        <p>
          Bautista Planning and Analytics, LLC is a registered investment adviser with the State of Oregon.
          Registration does not imply a certain level of skill or training. We may only provide
          individualized advice in states where we are registered or exempt from registration. Our Form ADV
          Part 2 brochure is available on request and through the link in the site footer.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Third-Party Links and Services</h2>
        <p>
          The site links to or uses services run by other companies, such as scheduling, account
          aggregation, and analytics providers. We do not control those services and are not responsible
          for their content, availability, or privacy practices. Their own terms and privacy policies apply
          when you use them.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Acceptable Use</h2>
        <ul>
          <li>Do not try to access accounts, data, or parts of the site you are not authorized to use.</li>
          <li>Do not interfere with the site's security or operation, or use automated tools to scrape it.</li>
          <li>Do not submit information about another person without their permission.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>Intellectual Property</h2>
        <p>
          Site content, logos, and calculators belong to Bautista Planning and Analytics, LLC or its
          licensors. You may view and print pages for personal, non-commercial use. Other copying or
          redistribution requires our written permission.
        </p>
      </section>

      <section className="privacy-section">
        <h2>No Warranty and Limitation of Liability</h2>
        <p>
          The site is provided "as is" and "as available." We try to keep information accurate and current
          but do not guarantee that it is complete, accurate, or free of errors, or that the site will
          always be available. To the extent permitted by law, BPA, LLC is not liable for losses arising from
          use of, or reliance on, the site or its calculators. Nothing in these terms waives rights you have
          under federal or state securities laws that cannot be waived.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Privacy</h2>
        <p>
          Our <a href="/privacy-policy">Privacy Policy</a> explains how we collect and use information,
          including cookies and analytics.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Changes and Governing Law</h2>
        <p>
          We may update these terms by posting a new version on this page. These terms are governed by the
          laws of the State of Oregon.
        </p>
      </section>

      <section className="privacy-section">
        <h2>Contact</h2>
        <p>
          Questions about these terms:{' '}
          <a href="mailto:joe@bautistaplanningandanalytics.com">joe@bautistaplanningandanalytics.com</a>{' '}
          or 458-227-9655.
        </p>
      </section>
    </main>
  );
}

export default TermsOfUsePage;
